import { useAuthStore } from '../lib/auth';

export function useAuthenticatedQuery() {
  const { isAuthenticated, token } = useAuthStore();
  
  return {
    enabled: isAuthenticated && !!token,
  };
}
